import { FETCH_ALL_NEWSLETTERS, FETCH_NEWSLETTER } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchNewslettersData = (page) => async (dispatch) =>
  await dispatch({
    type: FETCH_ALL_NEWSLETTERS,
    message: `All newsletters data`,
    payload: fetchService(`${baseUrl.backend}/api/newsletters?page=${page}`),
  });

export const fetchNewsletterData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_NEWSLETTER,
    message: `All newsletter data`,
    payload: fetchService(`${baseUrl.backend}/api/newsletters/${id}`),
  });
